import { Component, computed, effect, inject, input, model } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { FormBaseComponent, FormWrapperComponent, TextareaInputComponent } from '@pflegix/ui';
import { BusinessPartnerStore } from '../store';
import { NotesFormStore } from './store/notes-form.store';

@Component({
  selector: 'pfx-notes-form',
  imports: [ReactiveFormsModule, FormWrapperComponent, TextareaInputComponent],
  providers: [NotesFormStore],
  templateUrl: './notes-form.component.html',
})
export class NotesFormComponent extends FormBaseComponent {
  public businessPartnerId = input.required<string>();

  protected store = inject(NotesFormStore);

  protected bpStore = inject(BusinessPartnerStore);

  protected formBuilder = inject(FormBuilder);

  public loading = model(false);

  protected businessPartner = computed(() => this.bpStore.entityMap()[this.businessPartnerId() ?? '']);

  protected notesForm = this.formBuilder.group({
    notes: this.formBuilder.nonNullable.control<string | undefined>(undefined),
  });

  constructor() {
    super();

    effect(() => {
      const businessPartner = this.businessPartner();

      if (!businessPartner || !businessPartner.notes) {
        return;
      }

      this.notesForm.patchValue({ notes: businessPartner.notes });
    });

    // Use effects to automatically load business partner and set ID when businessPartnerId changes
    effect(() => {
      const businessPartnerId = this.businessPartnerId();

      this.bpStore.loadById(businessPartnerId);
      this.store.setBusinessPartnerId(businessPartnerId);
    });
  }

  protected async handleSubmit(): Promise<void> {
    const { invalid } = this.notesForm;

    if (invalid) {
      return;
    }

    await this.store.updateNotes(this.businessPartnerId(), this.notesForm.value || undefined);

    this.loadingFinished();
    this.resetForm();
  }

  protected handleEditCanceled(): void {
    this.resetForm();
  }

  private resetForm(): void {
    const businessPartner = this.businessPartner();

    this.notesForm.reset({ notes: businessPartner?.notes });
  }

  private loadingFinished(): void {
    this.loading.set(false);
  }
}
